import { useCallback } from 'react';
import { useNavigation } from '../context/NavigationContext';
import { MENU, notificationTargetMenu } from '../components/util/Utils';
import { Notification } from '../model/notification/Notification';

/**
 * Returns a handler that opens the entity a notification points at: it navigates
 * to the right screen by category and, when the notification carries a
 * referenceId, deep-links to the exact appointment/payment (the Appointments
 * screen opens its detail drawer; Payments filters to that appointment).
 * Shared by the bell dropdown and the Notifications page.
 */
export function useOpenNotification() {
    const { setActiveMenu, setPendingAppointmentId, setPendingPaymentAppointmentId, setPendingEventId } = useNavigation();

    return useCallback((n: Notification) => {
        const target = notificationTargetMenu(n.category);
        if (!target) return;
        const ref = n.referenceId ? String(n.referenceId) : null;

        if (target === MENU.PAYMENTS) {
            if (ref) setPendingPaymentAppointmentId(ref); // Payments filters to this appointment
        } else if (target === MENU.APPOINTMENTS) {
            if (ref) setPendingAppointmentId(ref); // Appointments opens this appointment's drawer
        } else if (target === MENU.CALENDAR && n.category?.startsWith('EVENT')) {
            if (ref) setPendingEventId(ref); // Calendar opens this EVENT's drawer
        }
        // WAITLIST / CLIENT: just navigate (no per-row deep-link in Phase 2).
        setActiveMenu(target);
    }, [setActiveMenu, setPendingAppointmentId, setPendingPaymentAppointmentId, setPendingEventId]);
}
